import React from 'react';
import { Spinner, Intent } from '@blueprintjs/core';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SMALL = 'pt-small';
const DEFAULT = 'pt-default';
const LARGE = 'pt-large';

class SpinnerContainer extends React.Component {

  render() {

    const {className, intent} = this.props;
    const Container = styled.div`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      flex: 1;
    `;

    return (
      <Container>
        <Spinner className={className} intent={intent}/>
      </Container>
    );
  }
}

SpinnerContainer.propTypes = {
  className: PropTypes.oneOf([SMALL, DEFAULT, LARGE]),
  intent: PropTypes.oneOf([
    Intent.NONE,
    Intent.PRIMARY,
    Intent.SUCCESS,
    Intent.WARNING,
    Intent.DANGER]
  )
};

SpinnerContainer.defaultProps = {
  className: LARGE,
  intent: Intent.NONE,
};

export default SpinnerContainer;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js